import type { HTTPMethod } from '@warp-drive/core-types/request';

import ApplicationAdapter from 'webapp/adapters/application';

export default class CustomQueryAdapter extends ApplicationAdapter {
	override ajaxOptions(url: string, type: HTTPMethod, options: JQueryAjaxSettings | RequestInit) {
		const hash = super.ajaxOptions(url, type, options);
		(hash as JQueryAjaxSettings).timeout = 5 * 60 * 1000; // 5min
		return hash;
	}
}
